import Swiper from 'swiper';

const FeaturedProductsSlider = () => {
  /* !----------------- SWIPER ------------------! */
  const containers = document.querySelectorAll('.product-card-slider .swiper-container');

  if (!containers.length) return;

  containers.forEach(container => {
    // get the id of the swiper, or its closest unique id
    const productCardSection = container.closest('.product-card-slider');
    const id = productCardSection?.parentElement?.id;

    new Swiper(container, {
      loop: false,
      slidesPerView: 'auto',
      spaceBetween: 40,
      //	breakpoints: {
      //		767: {
      //			slidesPerView: 1,
      //			spaceBetween: 10
      //		}
      //	},
      navigation: {
        nextEl: `#${id} .custom-button-next`,
        prevEl: `#${id} .custom-button-prev`,
      },
    });
  });
}

export default FeaturedProductsSlider;